export const ROUTE_PATH = {
  BASE: "",
  HOME: "home",
  QRCODE: "qrcode",
  INCENSES: "incenses",
  SPICES: "spices",
  PRODUCT_DETAILS: "product/details/",
  WHATSAPP: "https://wa.me/",
};

export const SERVER_API = {
  BASE: "https://api.shikritigroup.com",
  CONTACTS: "/Lookups/Contacts/",
  INCENSES: "/Lookups/Incenses/",
  SPICES: "/Lookups/Spices/",
  USER_LOGIN: "/Users/Login/",
  USER_LOGOUT: "/Users/Logout/",
  GET_ORDERS: "/Orders/AdminOrders/",
  CHANGE_ORDER_STATUS: "/Orders/ChangeStatus/",
};

export const OREDER_STATUS = {
  ALL: "ALL",
  ORDERED: "ORDERED",
  PAID: "PAID",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  INTRANSIT: "INTRANSIT",
  DELIVERED: "DELIVERED",
  DELETED: "DELETED",
};
